module.exports = __webpack_public_path__ + "img/3.6caba572.jpg";